"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const ledgerjs_hw_app_cardano_1 = __importStar(require("@cardano-foundation/ledgerjs-hw-app-cardano"));
const utils_1 = require("@cardano-foundation/ledgerjs-hw-app-cardano/dist/utils");
const logic_1 = require("./logic");
const types_1 = require("./types");
const constants_1 = require("./constants");
const typhonjs_1 = require("@stricahq/typhonjs");
const networks_1 = require("./networks");
const resolver = (transport, { path, verify, currency }) => __awaiter(void 0, void 0, void 0, function* () {
    const spendingPath = (0, logic_1.getBipPathFromString)(path);
    const stakingPathString = (0, logic_1.getBipPathString)({
        account: spendingPath.account,
        chain: types_1.StakeChain.stake,
        index: constants_1.STAKING_ADDRESS_INDEX,
    });
    const networkParams = (0, networks_1.getNetworkParameters)(currency.id);
    const network = networkParams.networkId === ledgerjs_hw_app_cardano_1.Networks.Mainnet.networkId ? ledgerjs_hw_app_cardano_1.Networks.Mainnet : ledgerjs_hw_app_cardano_1.Networks.Testnet;
    const ada = new ledgerjs_hw_app_cardano_1.default(transport);
    const r = yield ada.deriveAddress({
        network,
        address: {
            type: ledgerjs_hw_app_cardano_1.AddressType.BASE_PAYMENT_KEY_STAKE_KEY,
            params: {
                spendingPath: (0, utils_1.str_to_path)(path),
                stakingPath: (0, utils_1.str_to_path)(stakingPathString),
            },
        },
    });
    if (verify) {
        yield ada.showAddress({
            network,
            address: {
                type: ledgerjs_hw_app_cardano_1.AddressType.BASE_PAYMENT_KEY_STAKE_KEY,
                params: {
                    spendingPath: (0, utils_1.str_to_path)(path),
                    stakingPath: (0, utils_1.str_to_path)(stakingPathString),
                },
            },
        });
    }
    const address = typhonjs_1.utils.getAddressFromHex(r.addressHex);
    return {
        address: address.getBech32(),
        // Here, we use publicKey hash, as cardano app doesn't export the public key
        publicKey: address.paymentCredential.hash,
        path,
    };
});
exports.default = resolver;
//# sourceMappingURL=hw-getAddress.js.map